import axios from "axios";
import { request } from "@/utils/request";

/* 会员模块接口 */

/**
 * 查询
 * @param {*} data
 * @returns
 */
export function selectVipCard(data) {
  return request({
    url: `/admin/mall/vipCard/select`,
    method: "POST",
    data,
  });
}

/**
 * 新增
 * @param {*} data
 * @returns
 */
export function addVipCard(data) {
  return request({
    url: `/admin/mall/vipCard/add`,
    method: "POST",
    data,
  });
}

/**
 * 修改
 * @param {*} data
 * @returns
 */
export function updateVipCard(data) {
  return request({
    url: `/admin/mall/vipCard/update`,
    method: "POST",
    data,
  });
}



/**
 * 充值与消费
 * @param {*} data
 * @returns
 */
export function updateMoney(data) {
  return request({
    url: `/admin/mall/vipCard/updateMoney`,
    method: "POST",
    data,
  });
}

/**
 * 额度调整
 * @param {*} data
 * @returns
 */
export function updateMaxLimit(data) {
  return request({
    url: `/admin/mall/vipCard/updateMaxLimit`,
    method: "POST",
    data,
  });
}


/**
 * 删除
 * @param {*} data
 * @returns
 */
export function deleteVipCard(data) {
  return request({
    url: `/admin/mall/vipCard/delete`,
    method: "POST",
    data,
  });
}

